import React from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { AlertCircle, CheckCircle, XCircle } from 'lucide-react';

export const InhaberPendingRequests = ({ requests = [], onApprove, onReject }) => {
  if (!requests.length) return null;
  return (
    <Card className="bg-gray-900/50 border-orange-500/30 mb-8">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <AlertCircle className="h-5 w-5 text-orange-500" />
          Ausstehende Kursanfragen ({requests.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {requests.map((request) => (
            <div
              key={request.id}
              className="flex items-center justify-between bg-black/30 p-4 rounded-lg border border-gray-800"
              data-testid={`request-row-${request.id}`}
            >
              <div>
                <p className="text-white font-medium">{request.employeeName}</p>
                <p className="text-sm text-gray-400">möchte: <span className="text-yellow-500">{request.courseTitle}</span></p>
                {request.message && <p className="text-xs text-gray-500 mt-1">"{request.message}"</p>}
              </div>
              <div className="flex gap-2">
                <Button
                  size="sm"
                  className="bg-green-600 hover:bg-green-700"
                  onClick={() => onApprove(request.id)}
                  data-testid={`approve-btn-${request.id}`}
                >
                  <CheckCircle className="h-4 w-4 mr-1" /> Freischalten
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  className="border-red-500 text-red-500 hover:bg-red-500/10"
                  onClick={() => onReject(request.id)}
                  data-testid={`reject-btn-${request.id}`}
                >
                  <XCircle className="h-4 w-4 mr-1" /> Ablehnen
                </Button>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
